export default [
    //个人中心
    {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter/personalCenter.vue'),
        meta: {
            hasTabbar: true,
            title: '个人中心',
            barIndex: 1,
        }
    },
    //门票预约
    // {
    //     path: '/ticketBooking',
    //     name: 'ticketBooking',
    //     component: () => import('../views/personalCenter/ticketBooking.vue'),
    //     meta: {
    //         hasTabbar: true,
    //         title: '门票预约'
    //     }
    // },

    //通用列表
    {
        path: '/OrderList',
        name: 'OrderList',
        component: () => import(`@views/personalCenter/OrderList.vue`),
        meta: {
            // hasTabbar: true,
        }
    },
    //报名详情
    {
        path: '/OrderDetail',
        name: 'OrderDetail',
        component: () => import(`@views/personalCenter/OrderDetail.vue`),
        meta: {
            title: '订单详情'
        }
    },

    //二维码
    {
        path: '/QRCode',
        name: 'QRCode',
        component: () => import(`@views/personalCenter/QRCode.vue`),
        meta: {
            title: '门票'
        }
    },
    {
        path: '/orderDetails',
        name: 'orderDetails',
        component: () => import('../views/personalCenter/orderDetails.vue'),
        meta: {
            // hasTabbar: true,
            title: '订单详情'
        }
    },
    //志愿者报名
    {
        path: '/signUp',
        name: 'signUp',
        component: () => import('../views/personalCenter/signUp.vue'),
        meta: {
            hasTabbar: false,
            title: '志愿者报名'
        }
    },
    //志愿者活动
    {
        path: '/volunteerActivity',
        name: 'volunteerActivity',
        component: () => import('../views/personalCenter/volunteerActivity.vue'),
        meta: {
            hasTabbar: false,
            title: '志愿者活动'
        }
    },
    //志愿者排班
    {
        path: '/VolunteerSche',
        name: 'VolunteerSche',
        component: () => import('../views/personalCenter/VolunteerSche.vue'),
        meta: {
            hasTabbar: false,
            title: '志愿者排班'
        }
    },
    //志愿者报名详情
    {
        path: '/registrationDetails',
        name: 'registrationDetails',
        component: () => import('../views/personalCenter/registrationDetails.vue'),
        meta: {
            // hasTabbar: true,
            title: '志愿者报名详情',
        }
    },
    //服务指南
    {
        path: '/serviceGuide',
        name: 'serviceGuide',
        component: () => import('../views/personalCenter/serviceGuide.vue'),
        meta: {
            // hasTabbar: true,
            title: '服务指南'
        }
    },
    //关于我们
    {
        path: '/aboutus',
        name: 'aboutus',
        component: () => import('../views/personalCenter/aboutus.vue'),
        meta: {
            // hasTabbar: true,
            title: '关于我们'
        }
    },
    //积分明细
    {
        path: '/integral',
        name: 'integral',
        component: () => import('../views/personalCenter/integral.vue'),
        meta: {
            // hasTabbar: false,
            title: '服务指南'
        }
    },
    // 设置
    {
        path: '/settingPage',
        name: 'settingPage',
        component: () => import('../views/personalCenter/settingPage.vue'),
        meta: {
            title: '设置'
        }
    },
    // 修改手机号
    {
        path: '/changePhone',
        name: 'changePhone',
        component: () => import('../views/personalCenter/changePhone.vue'),
        meta: {
            title: '修改手机号'
        }
    },
    //海博堂订单 
    {
        path: '/order',
        name: 'order',
        component: () => import('../views/personalCenter/HaiBoTangOrder.vue'),
        meta: {
            hasTabbar: false,
            title: '海博堂订单'
        }
    },
    //海博堂订单详情 
    {
        path: '/HaiBoTangorderDetails',
        name: 'HaiBoTangorderDetails',
        component: () => import('../views/personalCenter/HaiBoTangOrderDetails.vue'),
        meta: {
            hasTabbar: false,
            title: '订单详情'
        }
    },
    //海博堂订单申请退款 
    {
        path: '/refunds',
        name: 'refunds',
        component: () => import('../views/personalCenter/HaiBoTangOrderRefunds.vue'),
        meta: {
            hasTabbar: false,
            title: '申请退款 '
        }
    },
    //海博堂订单评价 
    {
        path: '/appraisals',
        name: 'appraisals',
        component: () => import('../views/personalCenter/HaiBoTangOrderAppraisals.vue'),
        meta: {
            hasTabbar: false,
            title: '订单评价'
        }
    },
    //  我的预约讲解列表 
    {
        path: '/myExplainList',
        name: 'myExplainList',
        component: () => import('../views/personalCenter/myExplainList.vue'),
        meta: {
            title: '预约讲解'
        }
    },
    //志愿者二维码
    {
        path: '/qrcodev',
        name: "qrcodev",
        component: () => import('../views/personalCenter/QRCodeVolunteer.vue'),
        meta: {
            hasTabbar: false,
            title: '志愿者签到'
        }
    },
    //订单物流
    {
        path: '/logistics',
        name: "logistics",
        component: () => import('../views/personalCenter/orderLogistics.vue'),
        meta: {
            hasTabbar: false,
            title: '订单物流'
        }
    },
    // 文创订单
    {
        path: '/culproduct',
        name: 'culproduct',
        component: () => import('../views/personalCenter/CulProduct.vue'),
        meta: {
            hasTabbar: true,
            title: '文创订单'
        }
    },
];